let unregisteredUserConfig = {
  title: "",
  guest_max_clicks: 0,
  guest_image: "",
  guest_image_2: "",
  guest_image_3: "",
  auction_guest_image: "",
  auction_guest_image_2: "",
  auction_guest_image_3: "",
  title_2: "",
  title_3: "",
  guest_like_artwork: "Sign up below to like your first artwork! ❤️",
  guest_like_article: "Sign up below to like your first article! ❤️",
  guest_like_post: "Sign up below to like your first post! ❤️",
  guest_article_comment_add: "Sign up below to add comments on this article!",
  guest_article_comment_view: "Sign up below to see comments on this article!",
  guest_post_comment_add: "Sign up below to add comments on this post!",
  guest_post_comment_view: "Sign up below to see comments to this post!",
  guest_artlist_like: "Sign up below to like {username}'s Artlist!",
  guest_artlist_play: "Sign up below to play and enjoy {username}'s Artlist!",
  guest_follow: "Sign up below to start following {username} 👥",
  guest_profile: "Sign up below to claim your profile! 🎉",
  guest_purchase: "Sign up below to purchase {arwork_name} now!",
  guest_rating: "Sign up below to rate your first artwork 🌟",
  guest_rest: "New here? Welcome! Sign up below to begin your journey.",
  guest_thought: "Sign up below to share your thoughts on this artwork 💭",
  turnstile_site_key: null
};
  
export function getUnregisteredUserConfig() {
  return unregisteredUserConfig;
}

export function setUnregisteredUserConfig(newConfig) {
  unregisteredUserConfig = { ...unregisteredUserConfig, ...newConfig };
}
